export const fieldNames = { deskName: 'deskName' };
